import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/index/Header';
import cls from 'classnames';
import Request from '@/utils/Request';
import Brand from '@/components/index/Brand';
import styles from './index.module.scss';
import { Button, Pagination } from 'antd';
const brands = [
  {
    id: 95,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/0b/46/52/0b465237af9e4cf6b7c72c449faf9114.JPG',
    title: 'IDT',
    redirectUrl: 'https://sg.idtdna.com/',
    redirectUrlH5: null,
    sort: 1
  },
  {
    id: 96,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/f8/85/d9/f885d9e7e50b451ea513739183406e99.png',
    title: 'BECKMAN',
    redirectUrl: 'https://www.mybeckman.cn/',
    redirectUrlH5: 'https://www.mybeckman.cn/',
    sort: 2
  },
  {
    id: 97,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/b9/18/cd/b918cd25b36347b38d22222316f15d03.jpg',
    title: 'MD',
    redirectUrl: 'https://www.moleculardevices.cn/',
    redirectUrlH5: 'https://www.moleculardevices.cn/',
    sort: 3
  },
  {
    id: 98,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/b8/fa/2c/b8fa2c2f22704912b74b540dfcee76d3.jpg',
    title: 'SCIEX',
    redirectUrl: 'https://sciex.com.cn/',
    redirectUrlH5: 'https://sciex.com.cn/',
    sort: 4
  },
  {
    id: 99,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/90/69/d0/9069d01d2a354aa88d0ebce6d9b51db4.png',
    title: 'Agela飞诺美',
    redirectUrl: 'https://www.phenomenex.com.cn/',
    redirectUrlH5: 'https://www.phenomenex.com.cn/',
    sort: 5
  },
  {
    id: 100,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/f1/cf/39/f1cf395303e64fbba5698380901b6851.jpg',
    title: 'LEICA',
    redirectUrl: 'https://www.leica-microsystems.com.cn/cn/',
    redirectUrlH5: 'https://www.leica-microsystems.com.cn/cn/',
    sort: 6
  },
  {
    id: 78,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/0d/92/38/0d9238b3af8e4af288f370147612c096.png',
    title: 'ALDEVRON',
    redirectUrl: 'https://www.aldevron.com/',
    redirectUrlH5: null,
    sort: 7
  },
  {
    id: 103,
    url: 'https://uatshop.danaherlifesciences.com.cn/public/upload/23/e8/67/23e86724a02c4633a9909ffa7a979058.png',
    title: 'PALL',
    redirectUrl: 'https://i.pall.cn/',
    redirectUrlH5: null,
    sort: 8
  }
];
export default () => {
  const [searchParam] = useSearchParams();
  const [pageParam, setPageParam] = useState<Record<string, any>>({ page: 1, pageSize: 10, total: 0 });
  const [currentKey, setCurrentKey] = useState<string>('');
  const [dataSource, setDataSource] = useState<Array<Record<string, any>>>([]);
  const [homeData, setHomeData] = useState<any>(null);
  const initKeyword = useMemo(() => {
    return searchParam.get('keyword') || '';
  }, [searchParam]);
  useEffect(() => {
    setCurrentKey(initKeyword);
  }, [initKeyword]);
  const loadHomeData = useCallback(async () => {
    const res = await Request.post('/home', {});
    if (res.errno === 0) {
      setHomeData(res.data);
    }
  }, []);
  const loadData = useCallback(async () => {
    if (!currentKey) {
      return;
    }
    const res = await Request.post('/goods/list', { name: currentKey, ...pageParam });
    console.log('res====', res);
    setDataSource(res.data.list);
    const newParam = { ...pageParam };
    newParam.page = res.data.pageNum;
    newParam.pageSize = res.data.pageSize;
    newParam.total = res.data.total;
    setPageParam(newParam);
    if (res.data.total === 0) {
      loadHomeData();
    }
  }, [currentKey, JSON.stringify(pageParam), loadHomeData]);
  const searchHandle = useCallback(
    async (keyword: string) => {
      if (!keyword) {
        return;
      }
      setCurrentKey(keyword);
    },
    [pageParam]
  );
  const _changePage = useCallback(
    (pageNum: number, pageSize: number) => {
      const newPageParam = { ...pageParam };
      newPageParam.page = pageNum;
      newPageParam.pageSize = pageSize;
      setPageParam(newPageParam);
    },
    [pageParam]
  );
  const gotoDetail = useCallback((item: any) => {
    window.open(item.url);
  }, []);
  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <div className={styles['search-page']}>
      <Header onSearch={searchHandle} hasBorder={true} defaultSearchKeyWord={initKeyword} />
      <div className={styles['content-list']}>
        {dataSource?.length ? (
          <ul>
            {(dataSource || []).map((item: any) => {
              return (
                <li key={item.id}>
                  <div className={cls(styles['product-item'], 'flex', 'v-center')}>
                    <div className={styles['left-image-waper']}>
                      <img src={item.picUrl} className={styles['left-image']} />
                    </div>
                    <div className={cls(styles['right-content'], 'flex1')}>
                      <div className={styles['title']} dangerouslySetInnerHTML={{ __html: item.name }}></div>
                      <div
                        className={styles['content-row']}
                        dangerouslySetInnerHTML={{ __html: `货号:${item.bn}` }}
                      ></div>
                      <div className={styles['content-row']} dangerouslySetInnerHTML={{ __html: item.desc }}></div>
                    </div>
                    <Button type="primary" className={styles['right-btn']} onClick={() => gotoDetail(item)}>
                      查看详情
                    </Button>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className={styles['center-empty']}>
            <p style={{ paddingBottom: '15px' }}>没有搜索到相关商品，建议到品牌对应的官网查询</p>
            <Brand brands={brands} />
          </div>
        )}
        <Pagination
          current={pageParam.page}
          pageSize={pageParam.pageSize}
          total={pageParam.total}
          hideOnSinglePage={true}
          showTotal={(total) => `共${total}条`}
          onChange={(pageNum, pageSize) => _changePage(pageNum, pageSize)}
        />
      </div>
    </div>
  );
};
